import { inject, OnInit, signal } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from '../app.layout.service';
import { AppMenuitemComponent } from './app.menuitem.component';
import { NgFor, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FirebaseAuthProvider } from '@shared/modules/auth/providers/firebase';
import { DialogModule } from 'primeng/dialog';
// import { AuthService } from '@core/auth/services/auth.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    standalone: true,
    imports: [NgFor, NgIf, AppMenuitemComponent, DialogModule],
})
export class AppMenuComponent implements OnInit {
    model: any[] = [];
    userRole: any = '';
    // TO DO: Extender AuthService en vez de usar directamente FirebaseAuthProvider para respetar el patron strategy
    authService = inject(FirebaseAuthProvider);
    // authService = inject(AuthService);
    showModal = signal(false)
    helpBtn: any = { label: 'Necesito ayuda', icon: " pi pi-question-circle" }
    constructor(public layoutService: LayoutService) { }

    getFilteredMenu(menuItems: any[]) {
        return menuItems.map(section => ({
            ...section,
            items: section.items.filter(item =>
                !item.roles || item.roles.includes(this.userRole) // Show if no roles OR user has role
            )
        })).filter(section => section.items.length > 0); // Remove empty sections
    }
    // TO DO Agregar admin-guard
    async ngOnInit() {
        const menu = [
            {
                label: '',
                items: [


                    {
                        label: 'Inicio',
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/home'],
                        roles: ['admin', 'support', 'administration'],
                    },
                    {
                        label: 'Centro de Trámites',
                        icon: 'pi pi-comment',
                        items: [
                            {
                                label: 'Consorcistas registrados',
                                routerLink: ['/', 'reclamos'],
                                roles: ['administration'],
                                class: ['submenu-child']
                            },
                            {
                                label: 'Pedidos de llaves',
                                routerLink: ['/', 'key-requests'],
                                roles: ['administration'],
                                class: ['submenu-child']
                            },
                           /*  {
                                label: 'No registrados',
                                routerLink: ['/', 'consorcios', 'owners', 'pending'],
                                roles: ['administration'],
                                class: ['submenu-child']
                            }, */
                            // {
                            //     label: 'Conversaciones a retomar',
                            //     routerLink: ['/', 'preregistry'],
                            //     roles: ['administration'],
                            // },
                            {
                                label: 'Expensas: comprobantes y pedidos',
                                routerLink: ['/', 'expenses'],
                                roles: ['administration'],
                            },
                            {
                                label: 'Personas externas',
                                routerLink: ['/', 'consultas-externas'],
                                roles: ['administration'],
                                class: ['submenu-child']
                            },
                            {
                                label: 'Mensajes masivos',
                                routerLink: ['/', 'broadcast'],
                                roles: ['administration'],
                                class: ['submenu-child']
                            },
                        ]
                    },
                    // {
                    //     label: 'Consultas y reclamos',
                    //     icon: 'pi pi-comment',
                    //     routerLink: ['/', 'reclamos'],
                    //     roles: ['administration'],
                    // },
                    {
                        label: 'Trabajos',
                        /*  icon: 'pi pi-fw pi-wrench', */
                        icon: 'pi pi-fw pi-wrench',
                        routerLink: ['/', 'my-orders'],
                        roles: ['administration'],
                    },
                    /* {
                        label: 'Pliegos',
                        icon: 'pi pi-fw pi-copy',
                        routerLink: ['/', 'pliegos'],
                        roles: ['administration'],
                    }, */
                    /*  {
                         label: 'Presupuestos',
                         icon: 'pi pi-fw pi-id-card',
                         routerLink: ['/', 'orders'],
                         roles: ['admin', 'support', 'administration'],
                     }, */
                    {
                        label: 'Transacciones',
                        icon: 'pi pi-fw pi-id-card',
                        routerLink: ['/', 'transactions'],
                        roles: ['admin', 'support'],
                    },
                    {
                        label: 'Usuarios',
                        icon: 'pi pi-fw pi-users',
                        routerLink: ['/', 'users'],
                        roles: ['admin', 'support'],
                    },
                    {
                        label: 'Configuración',
                        icon: 'pi pi-cog',
                        routerLink: ['/', 'settings'],
                        roles: ['admin', 'support'],
                    },
                    {
                        label: 'Tablero',
                        icon: 'pi pi-fw pi-chart-line',
                        routerLink: ['/', 'dashboard'],
                        roles: ['admin', 'support'],
                    },
                    {
                        label: 'Consorcios',
                        icon: 'pi pi-th-large',
                        routerLink: ['/', 'consorcios'],
                        roles: ['administration'],
                    },
                    {
                        label: 'Prestadores',
                        icon: 'pi pi-users',
                        routerLink: ['/', 'my-providers'],
                        roles: ['administration'],
                    },
                    {
                        label: 'Historial de compras',
                        icon: 'pi pi-shopping-cart',
                        routerLink: ['/', 'purchase-history'],
                        roles: ['administration'],
                    },
                    // {
                    //     label: 'Facturación',
                    //     icon: 'pi pi-fw pi-dollar',
                    //     routerLink: ['/', 'bills'],
                    //     roles: ['administration'],
                    // }
                ],
            },
        ];


        this.authService.getLoggedUser().subscribe(user => {
            if (user) {
                this.userRole = user.type;

                if (this.userRole)
                    this.model = this.getFilteredMenu(menu);
            }
        });

    }
    openModal() {
        this.showModal.set(true)


    }
}
